import QuinielaLobby from './QuinielaLobby';
export default QuinielaLobby;
